import { render, staticRenderFns } from "./Tasks.vue?vue&type=template&id=5b547778&scoped=true&"
import script from "./Tasks.vue?vue&type=script&lang=ts&"
export * from "./Tasks.vue?vue&type=script&lang=ts&"
import style0 from "./Tasks.vue?vue&type=style&index=0&id=5b547778&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b547778",
  null
  
)

export default component.exports